import swal from 'sweetalert2';

export function TypeSuccess() {
  swal.fire({
    title: 'Appointment successfully booked!',
    text: '',
    timer: 5000,
    icon: 'success',
    customClass: {
      confirmButton: 'btn btn-success'
    },
    buttonsStyling: false,
  });
}

export function alert(message, icon = 'success') {
  let object: any = {
    icon: icon,
    timer: 5000,
    title: message,
    text: '',
    customClass: {
      confirmButton: icon === 'success' ? 'btn btn-success' : icon === 'error' ? 'btn btn-danger' : icon === 'info' ? 'btn btn-info' : 'btn btn-primary'
    },
    buttonsStyling: false,
  }
  swal.fire(object);
}

export function Rescheduled() {
  swal.fire({
    title: 'Appointment is Rescheduled!',
    text: '',
    icon: 'success',
    customClass: {
      confirmButton: 'btn btn-success'
    },
    buttonsStyling: false,
  });
}

export function joinedPulseright(message) {
  swal.fire({
    title: 'Appointment is Rescheduled!',
    text: 'Just a Step Away!\n' +
      ' Complete Your Practice Setup to Unlock Seamless Management',
    timer: 60 * 1000,
    icon: 'success',
    customClass: {
      confirmButton: 'btn btn-success'
    },
    buttonsStyling: false,
  });
}

export function TypeError(message) {
  swal.fire({
    title: 'Error!',
    text: message,
    icon: 'error',
    customClass: {
      confirmButton: 'btn btn-primary'
    },
    buttonsStyling: false,
  });
}


export function FlipXAnimation(billId: string, diff: number) {
  const alert_Message= diff < 0 ? 'Your subscription has expired Please make a payment to avoid service interruptions.' :
    `${diff === 0 ? 'Your subscription will expire today' : `Your subscription will expire in ${diff} ${diff === 1 ? 'day' : 'days'}`}. Please make a payment to avoid service interruptions.`;


  swal.fire({
    title: '',
    text: alert_Message,
    icon: 'warning',
    showClass: {
      popup: 'animated flipInX'
    },
    confirmButtonText: 'Make Payment', // custom button text
  }).then((result) => {
    if (result.isConfirmed) {
      console.log('Hi'); // action on button click
    }
  });
}

export function Flip_Animation(pending) {
  const alert_message = `Hey!  ${pending === 0 ? 'Your trial expires today' : `Your trial expires in ${pending} ${pending === 1 ? 'day' : 'days'}`}. Upgrade to continue.`;
  swal.fire({
    title: '',
    text: alert_message,
    showClass: {
      popup: 'animated flipInX'
    },
    icon: 'warning',
    buttonsStyling: false,
    confirmButtonColor: '#2F8BE6',
    confirmButtonText: 'Upgrade',
    customClass: {
      confirmButton: 'btn btn-primary',
    },
  }).then(function (result) {
    if (result.value) {
      swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Thank you for choosing Pulseright! You\'ll receive an email, or our support team will reach out to you based on your selected pricing plan.',
        customClass: {
          confirmButton: 'btn btn-success'
        },
      })
    }
  });
}
